import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getStoreInvoicePrinter, getStoreLocalData, getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";
import { getBrandStoreById } from "../../services/StoreUsers/PostStoreUsers";

const PaymentCollectionReceiptAdmin = () => {
  const { brandProfileData } = getUserData();

  let brand = brandProfileData;

  const location = useLocation();
  const {
    storeId,
    storeCustomerId,
    bookingOrderId,
    customerOrdersData,
    paymentDetails,
  } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const [storeData, setStoreData] = useState({})

  const { storeLocalData } = getStoreLocalData();
  
  const data = {
    storeName: storeData?.storeName,
    brandName: brand.name,
    fullAddress: storeData?.address?.fullAddress,
    mobileNumber: storeData?.mobileNo,
    email: storeData?.email,
    orderNo: customerOrdersData.orderNo,
    billNo: customerOrdersData.invoiceNo,
    date:
      new Date(paymentDetails.date)?.getDate() +
      "-" +
      parseInt(new Date(paymentDetails.date)?.getMonth() + 1) +
      "-" +
      new Date(paymentDetails.date)?.getFullYear(),
    customerName: customerOrdersData.customerName,
    mobileNo: customerOrdersData.customerMobile,
    receivedBy:
      paymentDetails.receiver.firstName +
      " " +
      paymentDetails.receiver.lastName,
    paymentMode: paymentDetails.paymentMode.replace(/_/g, " "),
    customerAddress: customerOrdersData.customerAddress,
    totalAmount: paymentDetails.amount,
  };

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  const fetchStoreUser = () => {
    getBrandStoreById(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
    if(!isConnected) 
      {
        connectToQZ();
      }

    fetchSelectedInvoicePrinter()
  }, [])
  
  const printInvoiceHTML = async () => {
    try {
      // const printer = await qz.printers.find("POS80 Printer"); // Adjust to your printer's actual name
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      const htmlContent = `
      <html>
        <body style="font-size: 12px; font-family: sans-serif;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;">Payment Receipt</span>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName}</p>
            <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
            <p style="font-size: 12px; margin: 0;">${data.email}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 15px; font-weight: bold; margin: 0;">Bill No.: ${data.billNo}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex; justify-content: space-between;">
               <span><strong>Order No.:</strong></span>
              <span>${data.orderNo}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span><strong>Date:</strong></span>
              <span>${data.date}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Received From:</strong></span>
              <span>${data.customerName}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Mobile No.:</strong></span>
              <span>${data.mobileNo}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Amount:</strong></span>
              <span>${storeLocalData?.currencySymbol + ' ' + data.totalAmount}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Payment Mode:</strong></span>
              <span>${data.paymentMode}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Received By:</strong></span>
              <span>${data.receivedBy}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
          </div>
        </body>
      </html>
    `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML receipt sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print receipt");
    }
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                      navigate(-1)
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Payment Receipt
              </p>
            </div>
            <div className="flex">
              <div className="mx-4 cursor-pointer" onClick={printInvoiceHTML}>
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="w-5 ">
          <div className="flex  justify-content-center flex-column print-section">
            <p className="text-3xl font-medium text-center">Payment Receipt</p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-7  border-dashed border-1 "></p>
            </div>
            <p className="text-xl font-medium text-center">{data.storeName}</p>
            <p className="text-lg font-normal text-center">
              {data.fullAddress}
            </p>
            <p className="text-lg font-normal text-center">
              {data.mobileNumber}
            </p>
            <p className="text-lg font-normal text-center">{data.email}</p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1 "></p>
            </div>
            <p className="text-xl font-medium text-center">
              Bill No. : {data.billNo}
            </p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1 "></p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Order No.:</p>
              <p className="text-lg font-normal text-right">{data.orderNo}</p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Date:</p>
              <p className="text-lg font-normal text-right">{data.date}</p>
            </div>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1 "></p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Received From:</p>
              <p className="text-lg font-normal text-right">
                {data.customerName}
              </p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Mobile No.</p>
              <p className="text-lg font-normal text-right">{data.mobileNo}</p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Amount:</p>
              <p className="text-lg font-normal text-right">
                {storeLocalData?.currencySymbol} {data.totalAmount}
              </p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Payment Mode:</p>
              <p className="text-lg font-normal text-right">
                {data.paymentMode}
              </p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-lg font-normal text-left">Received By :</p>
              <p className="text-lg font-normal text-right">
                {data.receivedBy}
              </p>
            </div>
            <div className="flex justify-content-center align-items-center">
              <p className="w-7  border-dashed border-1 "></p>
            </div>
            <p className="text-3xl font-medium text-center">
              Powered By {data.brandName}
            </p>
          </div>
        </div>

        <div
          className="mr-4 mt-4 cursor-pointer"
          onClick={() => window.print()}
        >
          <img
            src={"Icons/printer.png"}
            style={{
              width: 65,
            }}
          />
        </div>
      </div>
      {/* Menu component */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
                       @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PaymentCollectionReceiptAdmin;
